const STATUS_SCORE = {
  good: 1,
  acceptable: 2,
  caution: 3,
  critical: 4,
};

const SCORE_TO_STATUS = {
  1: "good",
  2: "acceptable",
  3: "caution",
  4: "critical",
};

const SA_REGION_TO_PROVINCE = {
  "western cape": "Western Cape",
  "cape town": "Western Cape",
  "eastern cape": "Eastern Cape",
  "gqeberha": "Eastern Cape",
  "port elizabeth": "Eastern Cape",
  "northern cape": "Northern Cape",
  kimberley: "Northern Cape",
  "free state": "Free State",
  bloemfontein: "Free State",
  "kwazulu-natal": "KwaZulu-Natal",
  "kwazulu natal": "KwaZulu-Natal",
  durban: "KwaZulu-Natal",
  "north west": "North West",
  mahikeng: "North West",
  gauteng: "Gauteng",
  johannesburg: "Gauteng",
  pretoria: "Gauteng",
  mpumalanga: "Mpumalanga",
  mbombela: "Mpumalanga",
  limpopo: "Limpopo",
  polokwane: "Limpopo",
};

const SOUTH_AFRICA_PROVINCES = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: { province: "Western Cape" },
      geometry: {
        type: "Polygon",
        coordinates: [[[17.2, -34.8], [20.9, -34.8], [22.8, -33.9], [22.7, -32.1], [20.2, -31.8], [18.0, -32.2], [17.2, -33.5], [17.2, -34.8]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "Northern Cape" },
      geometry: {
        type: "Polygon",
        coordinates: [[[16.5, -32.2], [24.3, -32.2], [24.3, -27.0], [19.0, -27.0], [17.3, -28.6], [16.5, -30.2], [16.5, -32.2]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "Eastern Cape" },
      geometry: {
        type: "Polygon",
        coordinates: [[[22.0, -34.4], [30.2, -34.4], [30.2, -31.0], [28.7, -30.0], [26.8, -30.4], [25.5, -31.8], [23.7, -32.2], [22.0, -33.0], [22.0, -34.4]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "Free State" },
      geometry: {
        type: "Polygon",
        coordinates: [[[24.3, -30.9], [29.9, -30.9], [29.9, -27.0], [26.0, -27.0], [24.3, -28.5], [24.3, -30.9]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "KwaZulu-Natal" },
      geometry: {
        type: "Polygon",
        coordinates: [[[28.1, -31.8], [32.2, -31.8], [32.2, -27.0], [30.0, -27.0], [28.7, -28.5], [28.1, -30.0], [28.1, -31.8]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "North West" },
      geometry: {
        type: "Polygon",
        coordinates: [[[23.2, -28.9], [28.6, -28.9], [28.6, -24.8], [24.9, -24.8], [23.2, -26.4], [23.2, -28.9]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "Gauteng" },
      geometry: {
        type: "Polygon",
        coordinates: [[[27.2, -26.9], [28.6, -26.9], [28.6, -25.7], [27.2, -25.7], [27.2, -26.9]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "Mpumalanga" },
      geometry: {
        type: "Polygon",
        coordinates: [[[28.2, -27.4], [32.0, -27.4], [32.0, -24.0], [29.4, -24.0], [28.2, -25.2], [28.2, -27.4]]],
      },
    },
    {
      type: "Feature",
      properties: { province: "Limpopo" },
      geometry: {
        type: "Polygon",
        coordinates: [[[26.4, -25.9], [31.8, -25.9], [31.8, -22.1], [28.0, -22.1], [26.4, -23.3], [26.4, -25.9]]],
      },
    },
  ],
};

function normalizeProvince(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  const key = raw.toLowerCase();
  return SA_REGION_TO_PROVINCE[key] || raw;
}

export function buildSouthAfricaProvinceChoropleth(signals = []) {
  const summary = new Map();

  for (const signal of signals) {
    const province = normalizeProvince(signal?.province || signal?.region);
    if (!province) continue;

    const incomingScore = STATUS_SCORE[String(signal?.status || "").toLowerCase()] || 2;
    const patients = Math.max(0, Number(signal?.patients || 0) || 0);
    const updated = String(signal?.updated || "");

    const current = summary.get(province);
    if (!current) {
      summary.set(province, {
        province,
        maxScore: incomingScore,
        patients,
        updated,
      });
      continue;
    }

    current.maxScore = Math.max(current.maxScore, incomingScore);
    current.patients += patients;
    if (updated && !current.updated) current.updated = updated;
  }

  return {
    type: "FeatureCollection",
    features: SOUTH_AFRICA_PROVINCES.features.map((feature) => {
      const province = feature?.properties?.province || "";
      const snap = summary.get(province);
      const maxScore = snap?.maxScore || 1;
      return {
        ...feature,
        properties: {
          ...feature.properties,
          status: SCORE_TO_STATUS[maxScore] || "good",
          score: maxScore,
          patients: snap?.patients || 0,
          updated: snap?.updated || "Today",
        },
      };
    }),
  };
}

